<div class="wrapper">
  <ng-container>
    <div id="loading" *ngIf="loading$ | async">
      <app-loading></app-loading>
    </div>
  </ng-container>
  
  <router-outlet></router-outlet>  
  
  <div class="footer" fxLayoutAlign="center">
      <app-powered-by></app-powered-by>
  </div>
</div>

